import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  tabWithFooter: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  footer: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400]),
    margin: '40px -40px -32px -40px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: '40px -24px -40px -24px'
    }
  },
  content: {
    flexGrow: '1'
  },
  leaseDetails: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center'
  },
  file: {
    '&.disabled': {
      position: 'relative',
      '&:after': {
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '1',
        top: '-10px',
        content: '""',
        display: 'block',
        position: 'absolute'
      }
    }
  },
  datePicker: {
    maxWidth: '180px',
    '&.disabled': {
      position: 'relative',
      '&:after': {
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '1',
        top: '-10px',
        content: '""',
        display: 'block',
        position: 'absolute'
      }
    }
  },
  leasePeriodSelector: {
    width: '180px',
    marginLeft: '10px'
  },
  emailFieldContainer: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-actionIcon': {
      width: '48px',
      height: '48px',
      backgroundColor: palette.shades[100],
      marginLeft: '10px'
    }
  }
}));
export default useStyles;